﻿import { createFileRoute } from "@tanstack/react-router";
import { PaginaRota } from "@/paginas/pg_produtos/produtos-editor";

export const Route = createFileRoute("/_authenticated/produtos-editor")({
  head: () => ({
    meta: [
      { title: "Edição de produto — Milky Moo Palmares" },
      { name: "description", content: "Formulário de edição de produtos e receitas." },
      { property: "og:title", content: "Edição de produto — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Formulário de edição de produtos e receitas.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: PaginaRota,
});
